import _ from 'lodash';
import queryString from 'query-string';

import { auth } from 'src/app/database';

export default class ApiClient {
  constructor({ apiUrl } = {}) {
    this.token = localStorage.getItem('access_token');
    this.apiUrl = apiUrl;
  }

  async validateToken() {
    try {
      const user = auth?.currentUser;

      if (user) {
        const token = await user.getIdToken();

        this.setToken(token);

        return token;
      }
    } catch (e) {
      console.warn('Token fetch failed', e);
    }
  }

  async request({ endpoint, method, params = {}, headers = {}, body, asJson = true }) {
    const head = { ...headers };
    const asFormData = !asJson;

    if (!this.token) {
      const token = await this.validateToken();

      head.Authorization = `Bearer ${token}`;
    }

    if (this.token) {
      head.Authorization = `Bearer ${this.token}`;
    }

    const clonedParams = _.cloneDeep(params);

    for (const item in clonedParams) {
      if (!clonedParams[item]) {
        delete clonedParams[item];
      }
    }

    const query = Object.keys(clonedParams).length
      ? `?${decodeURIComponent(queryString?.stringify(clonedParams))}`
      : '';
    const url = `${this.apiUrl}/${endpoint}${query}`;

    try {
      let payload = body;

      if (asJson && !asFormData) {
        payload = JSON.stringify(body);
        head['Content-Type'] = 'application/json';
      }

      if (asFormData) {
        payload = body;
      }

      const response = await fetch(url, {
        method,
        headers: head,
        body: payload,
      });

      if (response.status === 204) {
        return { message: 'Created' };
      }

      const data = await response.json();

      if (data && (response.status === 200 || response.status === 201)) {
        return data;
      }

      const errorCode = data?.error?.code;

      if (errorCode === 'WRONG_TOKEN' || errorCode === 'AUTHENTICATION_FAILED') {
        localStorage.clear();
        this.clearToken();
      }

      throw data;
    } catch (err) {
      console.warn('Unhandled exeption');
      console.warn(err);
      throw err;
    }
  }

  async downloadRequest({ endpoint, method = 'GET', params = {}, headers = {}, body }) {
    const head = { ...headers, 'Content-Type': 'application/json' };

    if (this.token) {
      head.Authorization = `Bearer ${this.token}`;
    }

    const query = Object.keys(params).length
      ? `?${decodeURIComponent(queryString.stringify(params))}`
      : '';

    const url = `${this.apiUrl}/${endpoint}${query}`;

    const payload = JSON.stringify(body);

    const response = await fetch(url, { method, headers: head, body: payload });

    if (!response.ok) throw new Error(`Download failed (${response.status})`);

    return response;
  }

  get(endpoint, params, headers, asJson = true) {
    return this.request({ endpoint, method: 'GET', params, headers, asJson });
  }

  post(endpoint, body = {}, headers = undefined, asJson) {
    return this.request({
      endpoint,
      method: 'POST',
      body,
      headers,
      asJson,
    });
  }

  download(endpoint, body = {}, params = undefined, headers = undefined) {
    return this.downloadRequest({
      endpoint,
      method: 'POST',
      body,
      headers,
      params,
    });
  }

  patch({ endpoint, body = {}, headers = undefined, asJson }) {
    return this.request({ endpoint, method: 'PATCH', body, headers, asJson });
  }

  put(endpoint, body = {}, headers = undefined, asJson = true) {
    return this.request({ endpoint, method: 'PUT', body, headers, asJson });
  }

  delete(endpoint, body = {}, headers, asJson = true) {
    return this.request({ endpoint, method: 'DELETE', body, headers, asJson });
  }

  setToken(token) {
    this.token = token;
  }

  clearToken() {
    this.token = undefined;
  }
}
